import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Spin, message, Input, Modal } from "antd";
import { LoginFormContext, LoginFormContextType } from "../../utils";
import SelectTeam, { TeamItem } from "./SelectTeam";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import {
  approveStatusEnum,
  ApprovaTeamUserInfo,
  ApprovaTeamUserInfoList,
  InviteUserInfo,
  TeamUserInfo
} from "@/types/LoginPage";
import { useTranslation } from "react-i18next";
import { getWebEnvObj } from "@/utils";
import colors from "@/components/styles/colors";
import styles from "../../index.module.less";
const {
  REACT_APP_OSS_BASE_URL = "https://focus-desktop.s3.cn-north-1.jdcloud-oss.com"
} = getWebEnvObj();

export default function ApplyingTeams() {
  const { service, authInfo: authData } = useContext<GlobalContextConfig>(GlobalContext);
  const { authInfo } = React.useContext<LoginFormContextType>(LoginFormContext);
  const { t } = useTranslation("common");
  const [approveList, setApproveList] = useState([] as ApprovaTeamUserInfoList);
  const accessToken = authData?.accessToken || authInfo.accessToken;
  useEffect(() => {
    if (accessToken) {
      service.focusService.setToken(accessToken);
      service.focusService
        .getApproveStatus()
        .then((res: any) => {
          setApproveList(res.records as ApprovaTeamUserInfoList);
        })
        .catch(() => {});
    }
  }, [accessToken]);
  if (!approveList?.length) return null;

  return (
    <div className={styles.approveListSpace}>
      <div className={styles["approveListSpace-title"]}>{t("login.applyingTeams")}</div>
      {approveList?.map((item: ApprovaTeamUserInfo, index: number) => {
        let desc = "";
        let style;
        if (item.approveStatus === approveStatusEnum.WAIT) {
          desc = t("login.waitPass");
          style = {
            color: colors.warn
          };
        } else if (item.approveStatus === approveStatusEnum.NO_PASS) {
          desc = t("login.rejected");
          style = {
            color: colors.danger
          };
        }
        return (
          <TeamItem
            // eslint-disable-next-line react/no-array-index-key
            key={`${item.teamId}-${index}`}
            title={item.teamFullName.slice(0, 2)}
            name={item.teamFullName}
            styles={style}
            rightComps={<div className={styles["apply-status"]}>{desc}</div>}
            clickHandle={() => {
              if (item.approveStatus === approveStatusEnum.WAIT) {
                message.warning(t("login.applyingTip"));
              }
            }}
          />
        );
      })}
    </div>
  );
}
